<script lang="ts">
	export let status = "";
	export let text = "";

</script>

<div
	class="status"
	class:pending={status === 'PENDING'}
	class:approved={status === 'APPROVED'}
	class:terminated={status === 'TERMINATED'}
	class:draft={status === 'DRAFT'}>
	{text}
</div>

<style lang="scss">
	.status {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 4px 8px;
		border-radius: 14px;

		&.pending {
			color: #46474b;
			background-color: #d8d9df;
		}

		&.approved {
			color: white;
			background-color: #6d6f76;
		}

		&.terminated {
			color: white;
			background-color: #f66d6c;
		}

		&.draft {
			color: #46474b;
			background-color: #bcbfc3;
		}
	}

</style>
